var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
export function loadImageFromBlob(blob) {
  return __awaiter(this, void 0, void 0, function* () {
    if ('createImageBitmap' in window) {
      const image = yield createImageBitmap(blob);
      return {
        image,
        width: image.width,
        height: image.height
      };
    }
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(blob);
      const image = new Image();
      image.onload = () => {
        URL.revokeObjectURL(url);
        resolve({
          image,
          width: image.naturalWidth,
          height: image.naturalHeight
        });
      };
      image.onerror = e => {
        URL.revokeObjectURL(url);
        reject(e);
      };
      image.src = url;
    });
  });
}